import { NavLink, Outlet, useMatch } from "react-router-dom";
import ModuleNavbar from "../ModuleNavbar";

export const Sidebar = () => {
  return (
    <>


      <nav className="app-nav" aria-label="Account Navigation">
        <ul className="nav-list">
          <NavItem to="/Profile" icon="bx bx-user" label="Account Info" />
          <NavItem to="/Payment" icon="bx bx-credit-card" label="Payments" />
          <NavItem to="/PaymentPlan" icon="bx bx-calendar" label="Pay Plans" />
          <NavItem to="/PaymentHistory" icon="bx bx-receipt" label="Pay History" />
        </ul>
      </nav>


    </>
  );
};

/* ================= Reusable Nav Item ================= */

const NavItem = ({ to, icon, label }) => {
  const match = useMatch({ path: to, end: true });

  return (
    <li className={match ? "active" : ""}>
      <NavLink to={to} style={{ textDecoration: "none" }}>
        <i className={icon}></i>
        <span>{label}</span>
      </NavLink>
    </li>
  );
};
